
import { useColorScheme } from '@/hooks/useColorScheme';
import colors from '@/constants/Colors';
import { useCallback, useMemo } from 'react';
import { colorResolver } from '@/helper/Color';

export const useThemeColor = (props = {}, colorName = 'text') => {
    
  const theme = useColorScheme() ?? 'light';
  
  const globalColorScheme = useMemo(() => theme, [theme]);

  const resolveColor = useCallback((color, type) => colorResolver({color, type, colorName}), [colorName]);

  const colorFromProps = useMemo(() => {

    if (props === null)
      return colors.theme[globalColorScheme][colorName];

    const base = typeof props === 'string' ? props : props[globalColorScheme] ?? null;
    const responseColor = resolveColor(base, globalColorScheme);

    return responseColor;
  
  }, [props, globalColorScheme, colorName]);

  return colorFromProps ? colorFromProps : colors.theme[globalColorScheme][colorName];
}
